import { lazy } from 'react';

import { PATHS } from '@/constants/page-paths';
import { RouteTypes } from '@/types/config-types';

export const publicRoutes: RouteTypes[] = [
  {
    path: PATHS.SIGN_IN,
    name: 'Sign In',
    routeKey: 'sign_in',
    component: lazy(() => import('@/pages/auth/SignIn')),
  },
  {
    path: PATHS.REGISTER,
    name: 'Register',
    routeKey: 'register',
    component: lazy(() => import('@/pages/auth/register/Register')),
  },
  {
    path: PATHS.REGISTER,
    name: 'Complete Register',
    routeKey: 'complete_register',
    component: lazy(() => import('@/pages/auth/register/CompleteRegister')),
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    name: 'Forgot Password',
    routeKey: 'forgot_password',
    component: lazy(() => import('@/pages/auth/ForgotPassword')),
  },
  {
    path: PATHS.RESET_PASSWORD,
    name: 'Forgot Password',
    routeKey: 'reset_password',
    component: lazy(() => import('@/pages/auth/ResetPassword')),
  },
  {
    path: PATHS.VERIFY_OTP,
    name: 'Verify OTP',
    routeKey: 'verify_otp',
    component: lazy(() => import('@/pages/auth/VerifyOtp')),
  },
  {
    path: PATHS.GOOGLE,
    name: 'Google Login',
    routeKey: 'google_login',
    component: lazy(() => import('@/pages/auth/SignIn')),
  },
];

export const publicRouteNames = publicRoutes.map((route) => route.name);

export const publicRoutePaths = publicRoutes.map((route) => route.path);

export default publicRoutes;
